exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.page[data-v-49890b65] {\n    padding-top: 20px;\n}\n", ""]);

// exports
